import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useCourseDetailPageConfig = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_DETAIL_PAGE_CONFIG(),
    queryFn: () => shopApi.fetchCourseDetailPageConfig(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_DETAIL_PAGE_CONFIG(),
    });
  };

  return {
    isLoading,
    isFetching,
    courseDetailPageConfig: data?.data,
    invalidate,
  };
};
